<template>
  <div class="flex items-center space-x-4">
    <!-- Print button -->
    <button
      @click="print"
      class="min-w-24 px-3.5 py-2.5 bg-neutral-100 hover:bg-neutral-200 text-neutral-800 text-sm font-medium rounded-lg flex items-center space-x-2"
    >
      <Printer :size="16" />
      <span>Udskriv</span>
    </button>
    <!-- Optional recommendation text -->
    <!--
    <p class="text-sm font-medium text-neutral-400">
      A4 format anbefales
    </p>
    -->
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { Printer } from 'lucide-vue-next';

// Define props
const props = defineProps({
  resolution: {
    type: Object,
    default: () => ({ width: 1920, height: 1080 }),
    validator: (value) => {
      return value.width > 0 && value.height > 0;
    }
  }
});

// Method to handle print action
const print = () => {
  // Create a new stylesheet for print
  const style = document.createElement('style');
  style.textContent = `
    @page {
      size: ${props.resolution.width}px ${props.resolution.height}px;
      margin: 0;
    }
    body {
      width: ${props.resolution.width}px;
      height: ${props.resolution.height}px;
    }
  `;
  document.head.appendChild(style);

  // Trigger print
  window.print();

  // Remove the stylesheet after printing
  document.head.removeChild(style);
};
</script>